import { Component, ReactNode, ComponentType } from 'react';

import ErrorLogger from './ErrorLogger';
import { AppConfig } from '../types/app';
import StaticError from '../pages/StaticError';

class ErrorBoundary extends Component<{
  FallbackComponent?: ComponentType<any>;
  identifier: string;
  config?: AppConfig;
  children?: ReactNode;
}> {
  public state = {
    hasError: false,
    error: null,
  };

  static getDerivedStateFromError(error: Error | null) {
    return { hasError: true, error };
  }

  render() {
    if (!this.state.hasError) {
      return (
        <ErrorLogger boundaryIdentifier={this.props.identifier}>
          {this.props.children}
        </ErrorLogger>
      );
    }

    const FallbackComponent = this.props.FallbackComponent;
    return FallbackComponent ? (
      <FallbackComponent
        config={this.props.config}
        details={this.state.error && (this.state.error as any).toString()}
      />
    ) : (
      <StaticError />
    );
  }
}

export default ErrorBoundary;
